import PropTypes from 'prop-types';
import styles from './styles.module.css';

const StarIcon = ({ filled = false }) => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2.5L14.82 8.21L21 9.24L16.5 13.77L17.64 20L12 16.9L6.36 20L7.5 13.77L3 9.24L9.18 8.21L12 2.5Z"
      fill={filled ? '#BC00EE' : 'none'}
      stroke="#BC00EE"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

StarIcon.propTypes = {
  filled: PropTypes.bool,
};

export const CampaignStarRating = ({ rating = 0, onChange }) => (
  <div className={styles.starRating} role="radiogroup" aria-label="Avaliação da campanha">
    {Array.from({ length: 5 }, (_, index) => {
      const value = index + 1;

      return (
        <button
          key={value}
          type="button"
          className={styles.starButton}
          onClick={() => onChange?.(value)}
          aria-label={`${value} estrela${value > 1 ? 's' : ''}`}
          aria-pressed={rating >= value}
        >
          <StarIcon filled={rating >= value} />
        </button>
      );
    })}
  </div>
);

CampaignStarRating.propTypes = {
  rating: PropTypes.number,
  onChange: PropTypes.func,
};
